var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#B3261E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_993_8456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_993_8456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 23.9249C15.5833 23.9249 15.2293 23.7793 14.938 23.488C14.646 23.196 14.5 22.8416 14.5 22.425C14.5 22.0083 14.646 21.6543 14.938 21.363C15.2293 21.071 15.5833 20.925 16 20.925C16.4167 20.925 16.7707 21.071 17.062 21.363C17.354 21.6543 17.5 22.0083 17.5 22.425C17.5 22.8416 17.354 23.196 17.062 23.488C16.7707 23.7793 16.4167 23.9249 16 23.9249ZM16 19.025C15.6167 19.025 15.2917 18.8916 15.025 18.625C14.7583 18.3583 14.625 18.0333 14.625 17.65V8.94995C14.625 8.56662 14.7627 8.24162 15.038 7.97495C15.3127 7.70828 15.6333 7.57495 16 7.57495C16.3833 7.57495 16.7083 7.70828 16.975 7.97495C17.2417 8.24162 17.375 8.56662 17.375 8.94995V17.65C17.375 18.0333 17.2377 18.3583 16.963 18.625C16.6877 18.8916 16.3667 19.025 16 19.025Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.ba924bba525bb403722332dd3cf93e50.svg";
export { ForwardRef as ReactComponent };